import type { ReactNode } from 'react';
import {
  ChatToolInteractionContext,
  type ChatToolInteractionContextValue,
} from './chat-tool-interaction';

type ChatToolInteractionProviderProps = {
  children: ReactNode;
  value: ChatToolInteractionContextValue;
};

export function ChatToolInteractionProvider({
  children,
  value,
}: ChatToolInteractionProviderProps) {
  return (
    <ChatToolInteractionContext.Provider value={value}>
      {children}
    </ChatToolInteractionContext.Provider>
  );
}
